import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, array, boolean, mixed, object, string } from "yup";
import "Forms/Schemas/customMethods";

export type InsuranceExpenseCustomItem = {
  expenseItemID?: string | null;
  type?: string;
  amount?: string;
  institution?: string;
  belongsTo?: string;
  period?: string;
  id?: string | null;
};

export type InsuranceExpenseFormType = {
  readonly aggregatedAmount?: string;
  readonly detailed?: boolean;
  readonly customItems?: InsuranceExpenseCustomItem[];
};

export const getInsuranceExpenseFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<InsuranceExpenseFormType> = (t) => {
  const customItemSchema = object({
    id: string().nullable().notRequired(),
    expenseItemID: string().nullable().notRequired(),
    type: string().required(t(Resources.Validation.Required)),
    amount: string()
      .required(t(Resources.Validation.Required))
      .greaterThanZero(t(Resources.Validation.Number.MoreThen, { count: 0 })),
    institution: string().optional(),
    belongsTo: string().optional(),
  });

  return object({
    detailed: boolean().optional(),

    aggregatedAmount: string().when(["detailed"], ([detailed], schema) =>
      !detailed
        ? schema.required(t(Resources.Validation.Required)).greaterThanZero(t(Resources.Validation.Number.MoreThen, { count: 0 }))
        : schema.optional(),
    ),

    customItems: array().when(["detailed"], ([detailed], schema) => {
      return detailed ? schema.of(customItemSchema).optional() : mixed().notRequired();
    }),
  }).defined();
};
